import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin({
  name: "ckweb:app",
  enforce: "pre",
  dependsOn: ["ckweb:auth", "ckweb:dev-console"],
  async setup($nuxt) {
    const appStore = useAppStore();

    $nuxt.hook("ckauth:busy", ({ busy, trigger }) => {
      if (trigger === "login" || trigger === "logout") {
        appStore.setProcessLoading("auth-busy", busy);
      }
    });

    devConsole.info("🛠️ ckBase: app hooked  🚀🚀🚀🚀🚀");
  },
});
